import getApiClient from '@/plugins/api-client'

export default {
    load(id) {
        const self = this,
            api = getApiClient(self.$store)

        api.get(`frequently_asked_questions/${id}`)
            .then(result => {
                self.question = result.data
            })
            .catch(error => {
                console.log(error)
            })
    },
    save() {
        const self = this,
            id = self.question.id

        if (id) {
            return self.update()
        }

        return self.create()
    },
    create() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        api.post('frequently_asked_questions', self.question)
            .then(() => {
                self.question = {
                    question: null,
                    answer: null
                }
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },
    update() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        api.patch(`frequently_asked_questions/${self.question.id}`, self.question, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.question = result.data
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },

    resetFormResult() {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = null
        })
        self.success = false
    }
}
